"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLocaleDateString = exports.getStartDateString = exports.sortByDateCreated = exports.dateCreatedComparator = exports.getStartDate = exports.getScheduleTbdMessage = void 0;
var tslib_1 = require("tslib");
var getScheduleTbdMessage = function (event) {
    try {
        if (event.scheduling.config.scheduleTbd) {
            return event.scheduling.config.scheduleTbdMessage || 'TBD';
        }
    }
    catch (e) {
        return;
    }
};
exports.getScheduleTbdMessage = getScheduleTbdMessage;
var getStartDate = function (event) {
    try {
        if (event.scheduling.config.startDate) {
            return new Date(event.scheduling.config.startDate);
        }
    }
    catch (e) {
        return;
    }
};
exports.getStartDate = getStartDate;
var dateCreatedComparator = function (a, b) {
    return new Date(a.created || 0).getTime() - new Date(b.created || 0).getTime();
};
exports.dateCreatedComparator = dateCreatedComparator;
var sortByDateCreated = function (events) {
    return tslib_1.__spreadArray([], tslib_1.__read(events)).sort(exports.dateCreatedComparator);
};
exports.sortByDateCreated = sortByDateCreated;
function getStartDateString(event, format) {
    if (!format) {
        return event.scheduling.formatted;
    }
    var startDate = exports.getStartDate(event);
    if (startDate) {
        return getLocaleDateString(startDate, format);
    }
    return exports.getScheduleTbdMessage(event);
}
exports.getStartDateString = getStartDateString;
function getLocaleDateString(date, format) {
    if (format === void 0) { format = {}; }
    var locales = format.locales, options = format.options, hideCurrentYear = format.hideCurrentYear;
    var isCurrentYear = new Date().getFullYear() === date.getFullYear();
    if (hideCurrentYear && options && isCurrentYear) {
        format.options.year = undefined;
    }
    return date.toLocaleDateString(locales || [], options);
}
exports.getLocaleDateString = getLocaleDateString;
//# sourceMappingURL=index.js.map